// extracted by mini-css-extract-plugin
module.exports = {"wrap":"UserMenu_wrap__qHtYD","user":"UserMenu_user__3Rc1r","button":"UserMenu_button__2daRv"};